import { connect } from 'react-redux';
import { toggleMenu } from '../actions/index';
import { menuItems, menuExtraItems } from '../defaults/menuItems';
// Components
import MobileMenu from '../components/layout/nav/mobileMenu/MobileMenu';

const mapStateToProps = (state) => {
  return {
    locale: state.localeSelector,
    menuState: state.menuToggler,
    items: menuItems,
    extra: menuExtraItems,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: (menuState) => {
      dispatch(toggleMenu(menuState));
    },
  };
};

const MobileMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileMenu);

export default MobileMenuContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/MobileMenuContainer.js
 **/